<template>
    <div class="animated fadeIn">
        <div class="kgr-row">
            <div class="kgr-postfix kgr-postfix--gutters kgr-postfix--top kgr-row">
                <div class="kgr-postfix__fluid">
                </div>
                <div class="kgr-postfix__fixed">
                    <button
                        class="kgr-button kgr-button--accent"
                        @click="showExamDialog"
                    >
                        <kgr-icon
                            icon-class="add"
                            small
                            circle
                            highlight
                            class="kgr-button__icon kgr-button__icon--left"
                        />
                        <span>{{ $t('Prüfung ablegen') }}</span>
                    </button>
                </div>
            </div>
            <div class="kgr-grid kgr-grid--columnGutters kgr-grid--inlineBlock">
            </div>
        </div>
        <kgr-exam-result-filter
            :club-id="clubId"
            :loading="loading"
            :examineeType="examineeType"
            storage-key="memberExamResultFilter"
            @onFilter="loadMemberExams($event)"
        />
        <hr class="kgr-separator" />
        <div>
            <kgr-member-exams-list
                :exams="exams"
                :member-id="memberId"
                :loading="loading"
                view="list"
            />
        </div>
        <kgr-exam-create-dialog
            :show="showDialog"
            :club-id="clubId"
            :loading="pendingCreate"
            :examinee-type="examineeType"
            @onClose="closeDialog"
            @onCreate="createMemberExam($event)"
        />
    </div>
</template>

<script>
import ClubExam from '../../js/dto/club/ClubExam.js';
import ExamCreateDialog from '../../components/exams/ExamCreateDialog.vue';
import ExamResultFilter from '../../components/exams/ExamResultFilter.vue';
import KgrIcon from '../../components/common/icon/Icon.vue';
import MemberExamsList from '../../components/members/exams/MemberExamsList.vue';
import MemberRepository from '../../js/repository/MemberRepository.js';

export default {
    components: {
        'kgr-icon': KgrIcon,
        'kgr-member-exams-list': MemberExamsList,
        'kgr-exam-result-filter': ExamResultFilter,
        'kgr-exam-create-dialog': ExamCreateDialog,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        memberId: {
            type: Number,
            required: true,
        },
        overviewUrl: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            showDialog: false,
            loading: false,
            pendingCreate: false,
            exams: [],
            examineeType: ClubExam.EXAMINEE_TYPE_MEMBER,
        };
    },
    computed: {
    },
    created() {
        this.loadMemberExams();
    },
    methods: {
        showExamDialog() {
            this.showDialog = true;
        },
        closeDialog() {
            this.showDialog = false;
        },
        createMemberExam(exam) {
            this.pendingCreate = true;

            MemberRepository.createMemberExam(this.memberId, exam.id)
                .then((id) => {
                    window.location = `/backend/clubs/members/${this.memberId}/exams/${id}/edit`;
                })
                .catch(() => this.$notify.error('Prüfung konnte nicht angelegt werden'))
                .finally(() => {
                    this.showExamDialog = false;
                });
        },
        loadMemberExams(filter) {
            this.loading = true;
            MemberRepository.findAllExamResults(this.memberId, filter)
                .then((exams) => this.exams = exams)
                .catch(() => this.$notify.error('error.loadingData'))
                .finally(() => this.loading = false);
        },
        onBack() {
            window.location = this.overviewUrl;
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
